// Dependencies
import React from 'react';
import radium from 'radium';
import CheckoutButtons from "../CheckoutButtons";
import { ThemeContext } from "../../../components/theme/Theme.jsx";

function CHECKOUT_ERROR(props) {
	const context = React.useContext(ThemeContext)
	const style = {
		container: {
			margin: 'auto',
		},
		error: {
			fontWeight: '600',
			textAlign: 'center',
		},
		buttonContainer: {
			marginTop: '3em',
		},
	};

	return (
		<div style={style.container}>
			<div style={style.error}
				dangerouslySetInnerHTML={{
					__html: context.themeManager.getThemeTextOrHardcodedDefault('checkoutErrorPageText'),
				}}/>

			<CheckoutButtons
				btnResetLabel={props.btnLabels.resetBtnLabel || context.themeManager.getThemeTextOrHardcodedDefault('backToSCBtnLabel')}
				onResetClick={() => props.reset({
					method: props.checkoutProps.method,
					provider: props.checkoutProps.provider
				})}
				hideNextButton={true}
				hideBackButton={true}
				btnResetStyle={'highlight'}
			/>
		</div>
	);
}

const RadiumCHECKOUT_ERROR = radium(CHECKOUT_ERROR);

/* if component is using radium set name (name is used in CheckoutDispatcherPage) */
RadiumCHECKOUT_ERROR.name = CHECKOUT_ERROR.name
export default RadiumCHECKOUT_ERROR;
